import React, { useState, useCallback } from 'react'
import styled from '@emotion/styled'
import { FcPlus, FcCancel } from 'react-icons/fc'
import { Actions, useAdministrationStateContext } from '../../components/state'
import { HorizontalFlex, IconButton, LabeledItem, Button, Textbox } from '../../components'
import { CdsServiceSpec, HeaderItem } from './cds.types'

const Content = styled.div`
    margin: 1rem;
`
const Service = styled.div`
    display: flex;
    margin: 0.5rem;
    border-radius: 2px 2px 2px 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
`

const RowItems = styled.div`
    flex-flow: column;
`

const RowItem = styled.div`
    margin: 0.5rem;
    display: flex;
    justify-items: left;
    align-items: center;
    width: auto;
    font-size: 10pt;
`

const Label = styled.div`
    font-weight: bold;
    margin-right: 0.5rem;
`

const StretchToFill = styled.div`
    flex: 1;
`

const DisplayDiv = styled.div`
  overflow-y: scroll;
  height: 10%;
`


export function CdsServices() {
    const { globalState: state, dispatch } = useAdministrationStateContext()

    const [url, setUrl] = useState<string>('')
    const [subscriptionKey, setSubscriptionKey] = useState<string>('')
    const [error, setError] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const LoadNewCds = useCallback((newUrl: string, newSubscriptionKey: string) => {
        async function populateService() {
            if (newUrl !== '') {
                try {
                    const headers = [{ key: 'mlx-cds-subscription-key', value: newSubscriptionKey } as HeaderItem]
                    const data = await http<CdsServiceSpec>(newUrl, headers)
                    for (const service of data.services) {
                        service.url = newUrl
                        service.headers = headers
                        const updatedServices = state.cdsServices.concat(service)
                        dispatch(Actions.SetCdsServices(updatedServices))
                        dispatch(Actions.SetPrefetchLoaded(false))
                    }
                } catch (error: any) {
                    setError(error.message)
                }
            }
            setLoading(false)
        }
        populateService()
    }, [state.cdsServices, dispatch])

    const removeUrl = (index: number) => {
        const updatedServices = state.cdsServices
        if (index > -1) {
            updatedServices.splice(index, 1)
            const AnotherUpdatedServices = [...updatedServices]
            dispatch(Actions.SetCdsServices(AnotherUpdatedServices))
        }
        setLoading(false)
    }

    async function http<T>(
        url: string,
        headerData: HeaderItem[]
    ): Promise<T> {
        const headers = new Headers({ 'Content-Type': 'application/json' })
        headerData.forEach(headerItem => {
            headers.append(headerItem.key, headerItem.value)
        })

        const response = await fetch(url, {
            method: 'GET',
            headers: headers,
        })
        const responseBody = await response.json()

        return responseBody
    }

    function urlChanged(event: React.ChangeEvent<HTMLInputElement>) {
        setUrl(event.target.value)
    }

    function subscriptionKeyChanged(event: React.ChangeEvent<HTMLInputElement>) {
        setSubscriptionKey(event.target.value)
    }

    async function addUrl() {
        setLoading(true)
        LoadNewCds(url, subscriptionKey)
        setError(undefined)
    }

    function AddService() {
        if (loading) {
            return <HorizontalFlex>
                <div>Loading cds service...</div>
            </HorizontalFlex>;
        }

        if (error) {
            return <div>
                <HorizontalFlex>
                    <StretchToFill>
                        <StretchToFill>
                            <LabeledItem title={'Url:'}>
                                <Textbox value={url} onChange={e => urlChanged(e)} />
                            </LabeledItem>
                        </StretchToFill>
                        <StretchToFill>
                            <LabeledItem title={'Subscription Key:'}>
                                <Textbox value={subscriptionKey} onChange={e => subscriptionKeyChanged(e)} />
                            </LabeledItem>
                        </StretchToFill>
                    </StretchToFill>
                    <Button onClick={addUrl}>
                        <HorizontalFlex>
                            <FcPlus size='1rem' />
                        </HorizontalFlex>
                    </Button>
                </HorizontalFlex>
                <div>Error loading cds service: {error}</div>
            </div>
        }

        return <HorizontalFlex>
            <StretchToFill>
                <StretchToFill>
                    <LabeledItem title={'Url:'}>
                        <Textbox value={url} onChange={e => urlChanged(e)} />
                    </LabeledItem>
                </StretchToFill>
                <StretchToFill>
                    <LabeledItem title={'Subscription Key:'}>
                        <Textbox value={subscriptionKey} onChange={e => subscriptionKeyChanged(e)} />
                    </LabeledItem>
                </StretchToFill>
            </StretchToFill>
            <Button onClick={addUrl}>
                <HorizontalFlex>
                    <FcPlus size='1rem' />
                </HorizontalFlex>
            </Button>
        </HorizontalFlex>
    }

    return <Content>
        <AddService />
        <DisplayDiv>
            {state.cdsServices.map(function (service, index) {
                return <Service key={index}>
                    <RowItems>
                        <RowItem>
                            <Label>Service Name:</Label>
                            <div>{service.title}</div>
                        </RowItem>
                        <RowItem>
                            <Label>Url:</Label>
                            <div>{service.url}</div>
                        </RowItem>
                        <RowItem>
                            <Label>Description:</Label>
                            <div>{service.description}</div>
                        </RowItem>
                    </RowItems>
                    <IconButton onClick={() => removeUrl(index)}>
                        <HorizontalFlex>
                            <FcCancel size='1rem' />
                        </HorizontalFlex>
                    </IconButton>
                </Service>
            })}
        </DisplayDiv>
    </Content>
}